import { render, staticRenderFns } from "./_BasicOptions.vue?vue&type=template&id=3b2a61a0&"
import script from "./_BasicOptions.vue?vue&type=script&lang=js&"
export * from "./_BasicOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports